import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SiteProvider } from "./lib/site";
import { AuthProvider, useAuth } from "./lib/auth";
import Landing from "./pages/Landing";
import Legal from "./pages/Legal";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Office from "./pages/Office";
import Admin from "./pages/Admin";

const homeFor = (user) => (user?.role === "admin" ? "/admin" : "/oficina");

const Protected = ({ role, children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="grid min-h-screen place-items-center bg-ink font-mono text-xs uppercase tracking-[0.14em] text-white/80" data-testid="auth-loading">
        Cargando…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== role) return <Navigate to={homeFor(user)} replace />;
  return children;
};

const withAuth = (el) => <AuthProvider>{el}</AuthProvider>;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SiteProvider><Landing /></SiteProvider>} />
        <Route path="/legal/:slug" element={<SiteProvider><Legal /></SiteProvider>} />
        <Route path="/login" element={withAuth(<Login />)} />
        <Route path="/admin/login" element={<Navigate to="/login" replace />} />
        <Route path="/registro" element={withAuth(<Register />)} />
        <Route path="/oficina" element={withAuth(<Protected role="distributor"><Office /></Protected>)} />
        <Route path="/admin" element={withAuth(<Protected role="admin"><Admin /></Protected>)} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
